<div class="icon-container">
  <mat-icon>{{ getIconName() }}</mat-icon>
</div>
<div class="content">
  <ng-content></ng-content>
</div>
